export function slugToParams(slug) {
    const parts = slug.split("/");
    return {
        category_slug: parts[0],
        hash: parts[1],
        title: parts[2],
    };
}

export function slugToArray(slug) {
    return slug.split("/");
}
